

<div class="content notification-center-content">

  <div class="sub-nav-menu details-sub-nav-menu">
    <div class="menu-wrapper">
      @for (action of formActions; track action) {
        <div class="nav-item">
          @if (getCondition(action) && getActionFilteredChildrenCount(action) > 0) {
            <a class="nav-item" (click)="getActionBody(action)">
              <p>{{action.Title}}</p>
            </a>
          }
          @if (action.Children.length > 0) {
            <div class="navi-sub-menu shadow">
              @for (child of getFilteredChildren(action.Children); track child) {
                <div class="nav-sub-menu-item">
                  @if (getCondition(child) && child.NavigationNodeRule?.RuleType < 7) {
                    <a (click)="getActionBody(child)">
                      <p>{{child.Title}}</p>
                    </a>
                  }
                  @if (child.Children.length > 0) {
                    <div class="navi-sub-menu shadow">
                      @for (ndchild of child.Children; track ndchild) {
                        <div class="nav-sub-menu-item">
                          <a (click)="getActionBody(ndchild)">
                            <p>{{ndchild.Title}}</p>
                          </a>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="inner sub">
    <div class="inner-sub">
      <div class="sub-content">
        <div class="inner-item-wrapper sub-content-form">
          <div class="SemSearchControl">
            <sem-search #searchBar [bindingPropertyName]="'Models'" [repositoryName]="'lucene'" [customPageSize]="10"
              [hideButtons]="'False'">
            </sem-search>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="not-wrapper task-not-wrapper">

    <div class="containers under-not">

      @if (currentItem != null) {
        <div class="side-popup side-popup-notification">
          <div class="top-bar">
            @if (showButtons == true) {
              <p>
              {{translationService.translate('galis_js_notification_center_approval_required')}}</p>
            }
            <div class="toolbar-actions">
              <div class="notification-close-popup-icon" (click)="closePopup()"></div>
              <!--<div class="separator"></div>
              <div class="download"></div>
              <div class="separator"></div>
              <div class="delete"></div>
              <div class="separator"></div>
              <div class="add"></div>-->
            </div>
          </div>
          <!-- -------------------------------------------------------   SIDE CONTENT -------------------------------------------------------------->
          <div class="popup-inner-content popuptask">
            <h1>{{currentItem.Title}}</h1>
            @if (checkDateCreated(currentItem)) {
              <p class="underline">
                {{translationService.translate('galis_js_notification_center_created')}}:
              {{currentItem.DateCreated | date: 'dd.MM.yyyy':'CET'}}</p>
            }
            @if (checkDueDate(currentItem)) {
              <p class="underline">
                {{translationService.translate('galis_js_notification_center_duedate')}}:
              {{currentItem.DueDate | date: 'dd.MM.yyyy':'CET'}}</p>
            }
            <p class="text"></p>
            <div class="text description">
              <span [innerHTML]="currentItem.Description"></span>
              <br>
                @if (checkIfTaskHasFile(currentItem)) {
                  <span (click)="downloadTaskFile(currentItem)"
                  class="task-file-download-link">Prenesi datoteko</span>
                }
              </div>
              @if (dynComp.model) {
                <div class="file-holder">
                  @for (file of dynComp.model.Medias; track file) {
                    <div class="sub-side-content">
                      <div class="attachment">
                        <div class="img"></div>
                      </div>
                      <p>{{file.Name}}</p>
                    </div>
                  }
                </div>
              }
              <!--
              <textarea placeholder="Add comments..."></textarea>
              -->
              <app-sem-dynamic-control #dynComp (modelChanged)="modelChanged($event)" [url]="currentItem.FormName"
              [entityId]="currentItem.EntityID"></app-sem-dynamic-control>
              @if (showButtons) {
                <div class="btn-group">
                  <button (click)="accept()"
                    class="accept">{{translationService.translate('galis_js_notification_center_accept')}}
                    @if (currentItem.TaskOutcomes) {
                      <div>
                        @if (acceptDD && currentItem.TaskOutcomes.length > 1) {
                          <div class="dd">
                            @for (taskoutcome of currentItem.TaskOutcomes; track taskoutcome) {
                              <p (click)="executeOutcome(taskoutcome)">
                              {{taskoutcome.Title}}</p>
                            }
                          </div>
                        }
                      </div>
                    }
                  </button>
                  <button (click)="decline()"
                  class="decline">{{translationService.translate('galis_js_notification_center_decline')}}</button>
                </div>
              }
            </div>
          </div>
        }
        <!-- -------------------------------------------------------   SIDE CONTENT -------------------------------------------------------------->

        <div class="notifications">

          <h1 class="table-header">{{ today | date : 'dd.MM.yyyy' :'CET'}} <span id="time"></span></h1>
          <!--<div class="table-controls table-controls-notification">
            
            
            <div class="number-of-pages-setting">
              <label>{{translationService.translate('galis_js_show')}}:</label>
              <div class="select-items">
                <select (change)="changeNumberOfPages($event)" [(ngModel)]="numberOfPagesValue">
                  <option value="5">5 {{translationService.translate('galis_js_recordsperpage')}}</option>
                  <option value="10">10 {{translationService.translate('galis_js_recordsperpage')}}</option>
                  <option value="15">15 {{translationService.translate('galis_js_recordsperpage')}}</option>
                  <option value="20">20 {{translationService.translate('galis_js_recordsperpage')}}</option>
                  <option value="25">25 {{translationService.translate('galis_js_recordsperpage')}}</option>
                  <option value="30">30 {{translationService.translate('galis_js_recordsperpage')}}</option>
                  <option value="35">35 {{translationService.translate('galis_js_recordsperpage')}}</option>
                  <option value="40">40 {{translationService.translate('galis_js_recordsperpage')}}</option>
                  <option value="45">45 {{translationService.translate('galis_js_recordsperpage')}}</option>
                  <option value="50">50 {{translationService.translate('galis_js_recordsperpage')}}</option>
                  <option value="100">100 {{translationService.translate('galis_js_recordsperpage')}}</option>

                </select>
              </div>
            </div>
            </div>
            -->
          
          <div class="grid-table">
            <div class="table-container">
              <div class="table-wrapper">
                <ng-scrollbar [visibility]="'hover'" [track]="'all'">
                  <table class="table table-hover" id="taskTable">
                    <thead>
                      <th class="numbering thSmall checkbox-th" [ngClass]="{'checkbox-bulk-table-head': bulkActionPresent == true}">
                        <div class="checkbox-bulk" (click)="checkboxBulkCheckAllItems()"
                          [ngClass]="{'checkbox-bulk-checked': checkboxAllItemsChecked == true}">
                          <input type="checkbox" name="checkboxAllItemsClicked" />
                          <span class="tooltip-text tooltip-text-checkbox">{{translationService.translate('galis_js_grid_oznaci_vse')}}</span>
                        </div>
                      </th>
                      <th class="sem-data-grid-th">
                        <p>{{translationService.translate('galis_js_notification_center_task')}}</p>
                      </th>
                      <th class="sorting-th sem-data-grid-th">
                        <p>{{translationService.translate('galis_js_notification_center_statustask')}}</p>

                        <div class="sorting-container"
                          (click)="sortDropDownClick('Complete', $event)"
                          [ngClass]="{'sorting-container-used': sortingFlags.Complete.SortingUsed}">
                          <span class="drop-down-sorting-icon">
                            @if (sortingFlags.Complete.SortingUsed == false) {
                              <img src="assets/css/images/platform/arrow-down-s.png"
                                />
                            }
                            @if (sortingFlags.Complete.SortingUsed) {
                              <img src="assets/css/images/platform/icon-down-black.png"
                                />
                            }
                          </span>

                          @if (sortingFlags.Complete.ShowSort) {
                            <div class="drop-down-sorting-container">
                              <div class="drop-down-sorting-item" (click)="setColumnSorting('Complete',0,$event)">
                                <p><img src="assets/css/images/platform/fill-10.png" />{{translationService.translate('galis_js_GridData_Ascending')}}</p>
                              </div>
                              <div class="drop-down-sorting-item" (click)="setColumnSorting('Complete',1,$event)">
                                <p><img src="assets/css/images/platform/filld-10.png" />{{translationService.translate('galis_js_GridData_Descending')}}</p>
                              </div>
                            </div>
                          }
                        </div>
                        @if (sortingFlags.Complete.SortingUsed) {
                          <div class="inuse-sorting-container">
                            @if (sortingFlags.Complete.SortDirection == 0) {
                              <img src="assets/css/images/platform/fill-10.png"
                                >
                            }
                            @if (sortingFlags.Complete.SortDirection == 1) {
                              <img src="assets/css/images/platform/filld-10.png"
                                />
                            }
                          </div>
                        }

                      </th>
                      <th class="sorting-th sem-data-grid-th">
                        <p>{{translationService.translate('galis_js_notification_center_taskcreated')}}</p>

                        <div class="sorting-container"
                          (click)="sortDropDownClick('DateCreated', $event)"
                          [ngClass]="{'sorting-container-used': sortingFlags.DateCreated.SortingUsed}">
                          <span class="drop-down-sorting-icon">
                            @if (sortingFlags.DateCreated.SortingUsed == false) {
                              <img src="assets/css/images/platform/arrow-down-s.png"
                                />
                            }
                            @if (sortingFlags.DateCreated.SortingUsed) {
                              <img src="assets/css/images/platform/icon-down-black.png"
                                />
                            }
                          </span>

                          @if (sortingFlags.DateCreated.ShowSort) {
                            <div class="drop-down-sorting-container">
                              <div class="drop-down-sorting-item" (click)="setColumnSorting('DateCreated',0,$event)">
                                <p><img src="assets/css/images/platform/fill-10.png" />{{translationService.translate('galis_js_GridData_Ascending')}}</p>
                              </div>
                              <div class="drop-down-sorting-item" (click)="setColumnSorting('DateCreated',1,$event)">
                                <p><img src="assets/css/images/platform/filld-10.png" />{{translationService.translate('galis_js_GridData_Descending')}}</p>
                              </div>
                            </div>
                          }
                        </div>
                        @if (sortingFlags.DateCreated.SortingUsed) {
                          <div class="inuse-sorting-container">
                            @if (sortingFlags.DateCreated.SortDirection == 0) {
                              <img src="assets/css/images/platform/fill-10.png"
                                >
                            }
                            @if (sortingFlags.DateCreated.SortDirection == 1) {
                              <img src="assets/css/images/platform/filld-10.png"
                                />
                            }
                          </div>
                        }

                      </th>
                      <th class="sorting-th sem-data-grid-th">
                        <p>{{translationService.translate('galis_js_notification_center_taskdeadline')}}</p>

                        <div class="sorting-container"
                          (click)="sortDropDownClick('DueDate', $event)"
                          [ngClass]="{'sorting-container-used': sortingFlags.DueDate.SortingUsed}">
                          <span class="drop-down-sorting-icon">
                            @if (sortingFlags.DueDate.SortingUsed == false) {
                              <img src="assets/css/images/platform/arrow-down-s.png"
                                />
                            }
                            @if (sortingFlags.DueDate.SortingUsed) {
                              <img src="assets/css/images/platform/icon-down-black.png"
                                />
                            }
                          </span>

                          @if (sortingFlags.DueDate.ShowSort) {
                            <div class="drop-down-sorting-container">
                              <div class="drop-down-sorting-item" (click)="setColumnSorting('DueDate',0,$event)">
                                <p><img src="assets/css/images/platform/fill-10.png" />{{translationService.translate('galis_js_GridData_Ascending')}}</p>
                              </div>
                              <div class="drop-down-sorting-item" (click)="setColumnSorting('DueDate',1,$event)">
                                <p><img src="assets/css/images/platform/filld-10.png" />{{translationService.translate('galis_js_GridData_Descending')}}</p>
                              </div>
                            </div>
                          }
                        </div>
                        @if (sortingFlags.DueDate.SortingUsed) {
                          <div class="inuse-sorting-container">
                            @if (sortingFlags.DueDate.SortDirection == 0) {
                              <img src="assets/css/images/platform/fill-10.png"
                                >
                            }
                            @if (sortingFlags.DueDate.SortDirection == 1) {
                              <img src="assets/css/images/platform/filld-10.png"
                                />
                            }
                          </div>
                        }

                      </th>
                      <!--<th>
                      <p>
                      {{translationService.translate('galis_js_notification_center_result')}}</p>
                    </th>-->
                    <th class="sem-data-grid-th">
                      <p>{{translationService.translate('galis_js_notification_center_taskfiles')}}</p>
                    </th>
                  </thead>
                  <tbody>
                    @for (task of searchComponent?.model?.Models; track task) {
                      <tr class="table-row-notification" (click)="itemSelectedInTable(task,$event)"
                        [ngClass]="{'task-click': checkIfCurrentClick(task) == true}">
                        <td stop-click-propagation class="bulk-checkbox numbering">
                          <div class="checkbox-bulk" stop-click-propagation (click)="checkboxBulkItemClicked(task)"
                            [ngClass]="{'checkbox-bulk-checked': checkedBulkItemStatus[resolvePropertyBinding(task,'Id')] == true}">
                            <input type="checkbox" name="resolvePropertyBinding(task,Id)" />
                          </div>
                        </td>
                        <td class="first-col">
                          <!--<input class="sem-noti-check-box" type="checkbox" (click)="itemSelected($event, task)"
                          *ngIf="task.Complete == false || task.CanOpenIfComplete == true" />-->
                          <p
                            [ngClass]="{'task-opened': checkIfOpened(task) == true, 'task-unread': checkIfOpened(task) == false}">
                          {{task.Title}}</p>
                        </td>
                        <td>
                          @if (task.Complete == false) {
                            <p>
                            {{translationService.translate('galis_js_notification_center_incomplete')}}</p>
                          }
                          @if (task.Complete == true) {
                            <p>
                              {{translationService.translate('galis_js_notification_center_complete')}}
                            </p>
                          }
                        </td>
                        <td>
                          <p>{{task.DateCreated | date:'dd.MM.yyyy HH:mm':'CET'}}</p>
                        </td>
                        <td>
                          <p>{{task.DueDate | date:'dd.MM.yyyy HH:mm':'CET'}}</p>
                        </td>
                        <td>
                          @for (taskFile of task.TaskFiles; track taskFile) {
                            <p>
                              <span class="task-file" (click)="downloadTaskFile(task)">{{taskFile.FileName}}</span>
                            </p>
                          }
                        </td>
                        <!--td style="min-width: 320px;">
                        <table class="additional-props">
                          <!--div *ngFor="let prop of task.ColumnProps" class="additional-props">
                          <tr *ngFor="let prop of task.ColumnProps">
                            <td>
                              <p class="prop-title">{{translationService.translate(prop.Title)}}:</p>
                            </td>
                            <td *ngIf="prop.Value != null" class="prop-value">
                              <p>{{prop.Value}}</p>
                            </td>
                            <td *ngIf="prop.Value == null">
                              <p class="prop-value">/</p>
                            </td>
                          </tr>
                        </table>
                      </td-->
                      <span class="tooltip-text data-grid-row-tooltip-text">Podrobnosti</span>
                    </tr>
                  }

                </tbody>
              </table>
            </ng-scrollbar>
          </div>
          @if (itemsLoaded) {
            <div class="table-footer pagination">
              <div class="pagination-container">
                @if (previousPage > 0) {
                  <div class="left-double" (click)="toFirstPage()"></div>
                }
                @if (previousPage > 0) {
                  <div class="left" (click)="pageChanged(previousPage)"></div>
                }
                @for (page of pages; track page) {
                  <p [ngClass]="{'active': page.Active == true}" (click)="pageChanged(page.Number)">{{page.Number}}</p>
                }
                @if (nextPage > 0) {
                  <div class="right" (click)="pageChanged(nextPage)"></div>
                }
                @if (nextPage > 0) {
                  <div class="right-double" (click)="toLastPage()"></div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
</div>